export default "__VITE_ASSET__DjnaIYeJ__"